import { IconButton } from "@mui/material"
import { Dispatch, MutableRefObject, ReactNode, SetStateAction } from "react"
import styled from "styled-components"
import { StyledSvgIcon } from "theme/shared"

const StyledSwiperControllerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  .swiper-button-disabled {
    display: block;
    opacity: 0.5;
    cursor: default;
    button {
      cursor: default;
    }
    pointer-events: none;
  }
`

type SwiperControllerRowProps = {
  className?: string
  prevRef: MutableRefObject<HTMLDivElement>
  nextRef: MutableRefObject<HTMLDivElement>
  children: ReactNode
  trackEvent?: () => void
  setActiveIndex?: Dispatch<SetStateAction<number>>
}

const SwiperControllerRow = ({
  className,
  prevRef,
  nextRef,
  trackEvent,
  children,
  setActiveIndex,
}: SwiperControllerRowProps) => {
  return (
    <StyledSwiperControllerRow className={className}>
      <div ref={prevRef}>
        <IconButton
          onClick={() => {
            setActiveIndex &&
              setActiveIndex((prev) => (prev === 0 ? 0 : prev - 1))
            if (trackEvent) trackEvent()
          }}
        >
          <StyledSvgIcon
            src={`/icons/fi_chevron-right.svg`}
            alt="right"
            $w={24}
            $h={24}
          />
        </IconButton>
      </div>
      {children}
      <div ref={nextRef}>
        <IconButton
          onClick={() => {
            setActiveIndex && setActiveIndex((prev) => prev + 1)
            if (trackEvent) trackEvent()
          }}
        >
          <StyledSvgIcon
            src={`/icons/fi_chevron-left.svg`}
            alt="left"
            $w={24}
            $h={24}
          />
        </IconButton>
      </div>
    </StyledSwiperControllerRow>
  )
}

export default SwiperControllerRow
